import { render } from "./getBranches.vue?vue&type=template&id=45279736&scoped=true"
import script from "./getBranches.vue?vue&type=script&lang=js"
export * from "./getBranches.vue?vue&type=script&lang=js"

import "./getBranches.vue?vue&type=style&index=0&id=45279736&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45279736"]])

export default __exports__